import { jsx as e } from "react/jsx-runtime";
//#region src/IconDetailPageExternalLink.tsx
function t(t) {
	return /* @__PURE__ */ e("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		...t,
		children: /* @__PURE__ */ e("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M1.007 8.008C1.1 6.976 2.01 6.197 3.08 6.197h9.514l.122.008a.9.9 0 0 1 .77.89c0 .496-.4.897-.892.897H3.081L2.996 8c-.133.026-.212.111-.212.182v8.595l.01.044c.03.074.135.146.287.146H19.73l.085-.007c.133-.027.213-.111.213-.183v-1.904l.007-.122a.894.894 0 0 1 1.227-.706.895.895 0 0 1 .55.828v1.904l-.008.175c-.093 1.031-1.002 1.81-2.074 1.81H3.08l-.176-.006C1.852 18.671 1 17.836 1 16.778V8.183zM17.603 5.07a.9.9 0 0 1 .343-.07H23v5.087l-.008.121a.89.89 0 0 1-.885.776l-.12-.007a.896.896 0 0 1-.77-.89V8.065l-5.019 5.05-.1.087a.89.89 0 0 1-1.162-.086.9.9 0 0 1 0-1.27l5.019-5.05h-2.01l-.12-.009a.895.895 0 0 1-.704-1.232.9.9 0 0 1 .482-.486",
			clipRule: "evenodd"
		})
	});
}
t.displayName = "IconDetailPageExternalLink";
//#endregion
export { t as default };

//# sourceMappingURL=IconDetailPageExternalLink.js.map